const handoverType = {
  received: 'received',
  returned: 'returned'
}

const handoverTypeId = {
  received: 1,
  returned: 2
}

const handoverNamePdf = {
  received: 'Handover',
  returned: 'Return'
}

const handoverDetails = [
  'BUSINESS BOUTIQUE DMCC',
  'Office 310 | Level No 3 | Jumeirah Bay X3',
  'Jumeirah Lakes Towers | Dubai | UAE',
  'Tel. +971 4 368 4884',
  'Email: uae@uae-consulting.com',
  'MAKSIM TSIAZHKIN | Managing Director'
]

const handoverTitle = {
  received: 'handover of original documents',
  returned: 'confirmation of original documents return'
}

const handoverClientText = {
  received: 'received',
  returned: 'returned'
}

const handoverUserText = {
  received: 'handed over the original set of documents to',
  returned: 'received the original set of documents from'
}

const handoverFooter = [
  'Business Boutique DMCC | License No. DMCC-233817 | Office 2404 | Saba 1 Tower | Cluster E',
  'Dubai, UAE | Tel. +971 4 368 48 84 | Email: uae@uae-consulting.com',
  'Business Boutique DMCC is registrated and licensed as a freezone company under the rules & regulations of DMCC'
]

export {
  handoverType,
  handoverTypeId,
  handoverDetails,
  handoverTitle,
  handoverClientText,
  handoverUserText,
  handoverFooter,
  handoverNamePdf
}



// WEBPACK FOOTER //
// ./src/constants/handover.js